<div class="footer-background">
  <div class="seal-wrap">
    <img src="assets/themes/ccsf/images/seal.svg" alt="Seal of the City and County of San Francisco" class="img-fluid">
  </div>
  <ui-footer></ui-footer>
</div>
